import { render, staticRenderFns } from "./detail-risk.vue?vue&type=template&id=a0883c78&scoped=true"
import script from "./detail-risk.vue?vue&type=script&lang=js"
export * from "./detail-risk.vue?vue&type=script&lang=js"
import style0 from "./detail-risk.vue?vue&type=style&index=0&id=a0883c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0883c78",
  null
  
)

export default component.exports